module.exports = __webpack_public_path__ + "static/media/check-circle-green.b0125fec.svg";